const tenantSourceOptions = [
  { key: 'emailpassword', value: 'emailpassword', label: 'Email / Password' },
  { key: 'saml', value: 'saml', label: 'SSO' },
];

const getTenantLabel = (name) => {
  if (!name) return '';

  if (name.toLowerCase() === 'emailpassword') return 'Email / Password';

  if (name.toLowerCase() === 'saml') return 'SSO';

  return '';
};

export { tenantSourceOptions, getTenantLabel };
